import { useMemo } from 'react';
import { useRestaurant } from '../api/restaurant';

export const useRestaurantSections = () => {
  const { data: restaurant, isLoading } = useRestaurant();

  return useMemo(() => ({
    sections: isLoading || !restaurant?.lokacii
      ? []
      : restaurant.planSections.map((lokacija) => ({
          id: lokacija.toLowerCase().replace(/\s+/g, '-'),
          name: lokacija,
        })),
    isLoading,
  }), [restaurant, isLoading]);
};